import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { User } from '../../models/user';
import { UserService } from '../../services/user.service';

@Component({
	templateUrl: './settlement-detail.html',
	selector: 'app-settlement-detail'
})
export class SettlementDetailComponent implements OnInit, OnDestroy, OnChanges {
	public dateToDisplay: any;
	public displayedColumns: string[] = ['item', 'settlement'];
	@Input() public settlementDetail;
	public user: User;
	public userSubscription: any;

	constructor(private _userService: UserService) {
	}

    buildDisplayColumns() {
        let cols = ['item'];
        if (this.user.showPrice) {
            cols.push('price');
        }
        if (this.user.showBaseAmount) {
            cols.push('base');
        }
        if (this.user.showDriverSplit) {
            cols.push('driverSplit');
        }
        if (this.user.showPercentOrder) {
            cols.push('driverPercent');
        }
        cols.push('settlement');
        this.displayedColumns = cols;
    }

	ngOnChanges(changes: SimpleChanges): void {
		if (this.settlementDetail.dateTotals) {
			this.dateToDisplay = this.settlementDetail.dateTotals[0].dueTimeTo.formattedDate;
		}
	}

	ngOnDestroy(): void {
		this.userSubscription?.unsubscribe();
	}

	ngOnInit(): void {
		this.userSubscription = this._userService.user$.subscribe((data) => {
			this.user = data;
            this.buildDisplayColumns();
		});
	}

	setDateToDisplay(date) {
		this.dateToDisplay = date;
	}
}
